import { useState, useEffect } from 'react'
import {
  useReservationRatesLazyQuery,
  useResourceTypesQuery,
  useChildrenQuery,
  useOriginsQuery,
  useReservationStatesQuery,
  useReservationsCreationQuery,
  useAdditionalServicesQuery,
} from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'

export function useReservationNewCRUD(propertyId: string, reservedResourceId?: string) {
  const { id: tenantId, currency } = useTenant()
  const [loading, setLoading] = useState(false)

  const [reservationRatesQuery, { loading: loadingReservationRates, data: reservationRates }] = useReservationRatesLazyQuery()

  const { data: additionalServiceResult, loading: loadingAdditionalServices } = useAdditionalServicesQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: { eq: propertyId },
      },
    },
  })

  const { data: reservationsResult, loading: loadingReservations } = useReservationsCreationQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: propertyId,
        id: { eq: reservedResourceId },
      },
    },
    skip: !reservedResourceId,
  })

  const { data: resourceTypesResult, loading: loadingResourceTypes } = useResourceTypesQuery({
    variables: {
      filter: {
        tenantId: {
          eq: tenantId,
        },
        propertyId: {
          eq: propertyId,
        },
      },
    },
  })

  const { data: childrenResult, loading: loadingChildren } = useChildrenQuery({
    variables: {
      filter: {
        tenantId: {
          eq: tenantId,
        },
        propertyId: {
          eq: propertyId,
        },
      },
    },
  })

  const { data: originsResult, loading: loadingOrigins } = useOriginsQuery({
    variables: {
      tenantId: tenantId,
      pms: true,
    },
  })

  const { data: reservationStatesResult, loading: loadingReservationStates } = useReservationStatesQuery({ variables: { tenantId: tenantId } })

  useEffect(() => {
    setLoading(loadingReservationRates || loadingResourceTypes || loadingChildren || loadingReservationStates || loadingOrigins || loadingReservations || loadingAdditionalServices)
  }, [loadingReservationRates, loadingResourceTypes, loadingChildren, loadingReservationStates, loadingOrigins, loadingReservations, loadingAdditionalServices])

  return { loading, currency, reservationRatesQuery, reservationRates, resourceTypesResult, childrenResult, reservationStatesResult, originsResult, reservationsResult, additionalServiceResult }
}
